import $ from 'jquery';

/**
 * Global client options
 */
export class Client {
    /**
     * @param {Object} information Client information
     * @param {number} information.appDomainId Client app domain ID
     * @param {string} information.language Client language
     * @param {string} information.group Client group
     *
     * @returns {undefined}
     */
    constructor(information) {
        this._information = information;
    }

    /**
     * @returns {Object}
     */
    getInformation() {
        return { ...this._information };
    }

    /**
     * @returns {Number}
     */
    getAppDomainId() {
        return this._information.appDomainId;
    }

    /**
     * @returns {string}
     */
    getLanguage() {
        return this._information.language;
    }

    /**
     * @returns {string}
     */
    getGroup() {
        return this._information.group;
    }
}

export default new Client($('#h24-client').data());



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/core/Client.js
 **/